import { registerFunctionalComponent } from 'js/lib/components/component'

function setStickyAdVisibility(visible) {
  document.querySelectorAll('.js-sticky_ad').forEach(ad => {
    ad.style.display = visible ? '' : 'none'
  })
}

registerFunctionalComponent(
  '.js-c-pages-adoption-stories-gallery-modal',
  'AdoptionStoriesGalleryModal',
  component => {
    const modal = document.getElementById('adoption-story-modal')

    const handleKeydown = event => {
      if (!modal || modal.getAttribute('data-state') !== 'open') return

      if (event.key === 'ArrowLeft') {
        component.element
          .querySelector('.js-adoption-story-modal-nav-prev .js-c-navigate button')
          ?.click()
      } else if (event.key === 'ArrowRight') {
        component.element
          .querySelector('.js-adoption-story-modal-nav-next .js-c-navigate button')
          ?.click()
      }
    }

    component.useHandler(() => {
      document.addEventListener('keydown', handleKeydown)

      if (modal) {
        if (modal.getAttribute('data-state') === 'open') {
          setStickyAdVisibility(false)
        }

        const observer = new MutationObserver(() => {
          setStickyAdVisibility(modal.getAttribute('data-state') !== 'open')
        })

        observer.observe(modal, { attributes: true, attributeFilter: ['data-state'] })

        return () => {
          document.removeEventListener('keydown', handleKeydown)
          observer.disconnect()
          setStickyAdVisibility(true)
        }
      }

      return () => document.removeEventListener('keydown', handleKeydown)
    })
  }
)
